var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-check-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M16.6663 10.4165V5.6665C16.6663 4.26637 16.6663 3.56631 16.3939 3.03153C16.1542 2.56112 15.7717 2.17867 15.3013 1.93899C14.7665 1.6665 14.0665 1.6665 12.6663 1.6665H7.33301C5.93288 1.6665 5.23281 1.6665 4.69803 1.93899C4.22763 2.17867 3.84517 2.56112 3.60549 3.03153C3.33301 3.56631 3.33301 4.26637 3.33301 5.6665V14.3332C3.33301 15.7333 3.33301 16.4334 3.60549 16.9681C3.84517 17.4386 4.22763 17.821 4.69803 18.0607C5.23281 18.3332 5.93288 18.3332 7.33301 18.3332H9.99967M11.6663 9.1665H6.66634M8.33301 12.4998H6.66634M13.333 5.83317H6.66634M12.083 15.8332L13.7497 17.4998L17.4997 13.7498",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.7c015a15.svg";
export { ForwardRef as ReactComponent };